import { useEffect } from 'react';

/**
 * Run async load effects with automatic abort on unmount or when deps change.
 * Use for page/table initial data fetches so leaving a tab cancels in-flight API calls.
 *
 * @param {(signal: AbortSignal, isActive: () => boolean) => void | Promise<void>} effect
 * @param {React.DependencyList} deps
 */
export default function useAbortableEffect(effect, deps) {
    useEffect(() => {
        const controller = new AbortController();
        const isActive = () => !controller.signal.aborted;

        void Promise.resolve(effect(controller.signal, isActive));

        return () => controller.abort();
    }, deps);
}
